import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Image, Space, Typography, Button, Grid } from 'antd';
import ImageBanner from '../../assets/img/banner.png';

const { useBreakpoint } = Grid;
const { Text } = Typography;

function Banner() {
  let { xs, xxl } = useBreakpoint()
  return (
    <React.Fragment>
      <Row style={{ padding: 0, position: 'relative', backgroundColor: '#fff' }}>
        <Col span={24}>
          <Space direction="vertical" size={16} style={xxl ? { zIndex: 1, paddingLeft: 300, paddingTop: 130, marginBottom: -100, position: 'absolute' } : xs ? { zIndex: 1, paddingLeft: 16, paddingTop: 150, marginBottom: -100, position: 'absolute' } : { zIndex: 1, paddingLeft: 50, paddingTop: 130, marginBottom: -100, position: 'absolute' }}>
            <Space direction="vertical">
            </Space>
            <Space direction="vertical" size={xs ? -8 : -16}>
              <Text style={{ fontSize: xs ? 30 : 34, fontWeight: 'bold', color: '#fff' }}>WCHSS</Text>
              <Text style={{ fontSize: xs ? 20 : 26, color: '#fff' }}>The 1st World Conference on Health and</Text>
              <Text style={{ fontSize: xs ? 20 : 26, color: '#fff' }}>Social Sciences</Text>
            </Space>
            <Space direction="vertical" size={xs ? -8 : -16}>
              <Text style={{ fontSize: xs ? 18 : 20, color: '#fff' }}>October 28 – 29, 2022</Text>
              <Text style={{ fontSize: xs ? 18 : 20, color: '#fff' }}>Binawan University, Jakarta,  Indonesia</Text>
            </Space>
            <Link to='/registration'>
              <Button className="button-submit">Submit Now</Button>
            </Link>
          </Space>
          <Image
            width={'100%'}
            height={ 560 }
            src={ImageBanner}
            preview={false}
            style={{ objectFit: 'cover' }}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default Banner